/* eslint-disable import/prefer-default-export */
import Filter from './badwordsFilter';

const createFilter = (data) => {
    const filter = new Filter(data);
    return filter;
};

export function isProfane(text, words) {
    if (typeof text === 'string') {
        return createFilter(words).isProfane(text);
    }
    return false;
}
